import { render, staticRenderFns } from "./DestWarehouse.vue?vue&type=template&id=0edcf1ec&"
import script from "./DestWarehouse.vue?vue&type=script&lang=js&"
export * from "./DestWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports